module.exports = __webpack_public_path__ + "img/paulcoverdellctr-h_1-474x356.8dbba217.jpg";